import _ from 'lodash';
import { ServiceManager } from '@jutro/services';

function PropertyIncident(data) {
    const localeService = ServiceManager.getService('locale-service');
    this.address = null;
    this.lossEstimateValue = null;
    this.haveLossEstimate = null;
    

    if (data) {
        _.extend(this, data);
    }
}

export default PropertyIncident;
